export const SecurityOperations = {

    requisition: {
        requisitionManagement: "RequisitionManagement",
        requisitionCreate: "RequisitionCreate", //draft requisitions
        requisitionUpdate: "RequisitionUpdate",
        requisitionDelete: "RequisitionDelete",
        requisitionSubmit: "RequisitionSubmit",
        requisitionReject: "RequisitionReject",
        requisitionProcess: "RequisitionProcess",
        requisitionComplete: "RequisitionComplete",
        requisitionIncomplete: "RequisitionIncomplete",
        requisitionCreateInvoice: "RequisitionCreateInvoice",
        requisitionCreateCheque: "RequisitionCreateCheque",
        requisitionCreatePayment: "RequisitionCreatePayment",
        requisitionViewPayment: "RequisitionViewPayment",
        requisitionAddNewFile: "RequisitionAddNewFile",
        requisitionUpdatePrice: "RequisitionUpdatePrice",
        requisitionReadAll: "RequisitionReadAll",
        requisitionReadLimitedToOwner: "RequisitionReadLimitedToOwner",
        requisitionRefundPayment: "RequisitionRefundPayment",
        requisitionDeleteInvoice: "RequisitionDeleteInvoice",
        requisitionDeleteCheque: "RequisitionDeleteCheque",
        requisitionReadLimitedToScope: "RequisitionReadLimitedToScope",
    },

    timeLine: {
        timeLineManagement: "TimeLineManagement",
        timeLineRead: "TimeLineRead",
        TimeLineReadLimitedToOwner: "TimeLineReadLimitedToOwner",
        timeLineCreateNote: "TimeLineCreateNote",
        timeLineCreateEmail: "TimeLineCreateEmail",
    },

    client: {
        clientManagement: "ClientManagement",
        /// <summary>
        /// Read all clients from all tenants.
        /// </summary>
        clientReadAll: "ClientReadAll",

        /// <summary>
        /// Read clients from tenant only.
        /// </summary>
        clientRead: "ClientRead",
        clientCreate: "ClientCreate",
        clientDelete: "ClientDelete",
        clientUpdate: "ClientUpdate",
        /// <summary>
        /// Read clients limited to the owner that created them.
        /// </summary>
        clientReadLimitedToOwner: "ClientReadLimitedToOwner",
        clientExport: "ClientExport",
        clientImport: "ClientImport",
    },
    businessUnit: {
        businessUnitManagement: "BusinessUnitManagement",
        businessUnitRead: "BusinessUnitRead",
    },
    security: {
        operationManagement: "OperationManagement",
        operationRead: "OperationRead",
        authorizationContextRead: "AuthorizationContextRead",
        authorizationContextUpdate: "AuthorizationContextUpdate",
        authorizationContextCreate: "AuthorizationContextCreate",
    },

    importExport: {
        importExportManagement: "ImportExportManagement",
    },

    account: {
        accountManagement: "AccountManagement",
        accountRead: "AccountRead",
        accountCreate: "AccountCreate",
        accountUpdate: "AccountUpdate",
        accountReadLimitedToOwner: "AccountReadLimitedToOwner",
        accountDelete: "AccountDelete",
        accountExport: "AccountExport",
        accountImport: "AccountImport",
    },

    user: {
        userManagement: "UserManagement",
        userCreate: "UserCreate",
        userUpdate: "UserUpdate",
        userReadAll: "UserReadAll",
        userRead: "UserRead",
        userReadLimitedToOwner: "UserReadLimitedToOwner",
        userReadESignature: "UserReadESignature",
        userReadLimitedToScope: "UserReadLimitedToScope",
    },

    apiKeys: {
        apiKeysManagement: "ApiKeyManagement",
        apiKeyCreate: "ApiKeyCreate",
    },
    email: {
        emailManagement: "EmailManagement",
        sendEmailTemplate: "SendEmailTemplate",
        sendEmail: "SendEmail",
        emailTemplateRead: "EmailTemplateRead",
        emailTemplateUpdate: "EmailTemplateUpdate",
        emailTemplateCreate: "EmailTemplateCreate",
    },

    dashboard: {
        dashboards: "Dashboards",
        analytics: "DashboardAnalytics",
        csr: "DashboardCsr",
        ecommerce: "DashboardEcommerce",
        projects: "DashboardProject",
        invoice: "DashboardInvoice"
    },

    marketplace: {
        marketplace: "Marketplace",
        explore: "Explore",
    },

    project: {
        projects: "Projects",
        statistics: "Statistics",
        projectManagement: "ProjectManagement",
        projectRead: "ProjectRead",
        projectNew: "ProjectNew",
    },

    task: {
        taskManagement: "TaskManagement",
        taskCreate: "TaskCreate",
        taskUpdate: "TaskUpdate",
        taskReadLimitedToOwner: "TaskReadLimitedToOwner",
        taskDelete: "TaskDelete",
        taskReadAll: "TaskReadAll",
    },

    job: {
        jobManagement: "JobManagement",
        jobReadAll: "JobReadAll",
        //jobUpdate:"JobUpdate",
        jobCreate: "JobCreate",
        jobDelete: "JobDelete",
        jobReadLimitedToOwner: "JobReadLimitedToOwner",
    },

    file: {
        fileManager: "FileManager",
        fileCreate: "FileCreate",
        fileDelete: "FileDelete",
        fileReadLimitedToOwner: "FileReadLimitedToOwner",
        fileReadAll: "FileReadAll",
        fileCustomPermissions: "FileCustomPermissions"
    },
    system: {
        systemManagement: "SystemManagement",
        hangfire: "Hangfire",
    },
    ai: {
        loadFileToKnowledgeBase: "LoadFileToKnowledgeBase",
        aiDocumentInsights: "RAGDocument"
    },
    ocr: {
        createPdfColorHighlightedSearchTermsFile: "CreatePdfColorHighlightedSearchTermsFile",
        processOCR: "ProcessOCR"
    },

    invoice: {
        invoiceManagement: "InvoiceManagement",
        invoiceReadLimitedToOwner: "InvoiceReadLimitedToOwner",
        invoiceReadAll: "InvoiceReadAll",
        billingManagement: "BillingManagement",
        billingManagementLimitedToOwner: "BillingManagementLimitedToOwner",
        invoiceReadBillingHistory: "InvoiceReadBillingHistory"
    },

    blog: {
        blogCreate: "BlogCreate",
        blogUpdate: "BlogUpdate",
        blogDelete: "BlogDelete"
    },

    wallet: {
        walletManagement: "WalletManagement"
    }
}